// Version check and cache invalidation for iOS home screen apps
export const APP_VERSION = '1.0.1'; // Increment this on each deployment
export const BUILD_TIME = Date.now();

export function checkForUpdates() {
  // Only check in standalone mode (iOS home screen app)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                       (window.navigator as any).standalone === true;

  if (!isStandalone) {
    // Regular web - browser handles caching normally
    return;
  }

  const STORAGE_KEY = 'app_version';
  const LAST_CHECK_KEY = 'last_version_check';
  const CHECK_INTERVAL = 3600000; // 1 hour

  const lastCheck = localStorage.getItem(LAST_CHECK_KEY);
  const now = Date.now();

  // Don't check too frequently
  if (lastCheck && (now - parseInt(lastCheck, 10)) < CHECK_INTERVAL) {
    return;
  }

  localStorage.setItem(LAST_CHECK_KEY, now.toString());

  const storedVersion = localStorage.getItem(STORAGE_KEY);

  if (!storedVersion) {
    // First launch after adding version tracking
    localStorage.setItem(STORAGE_KEY, APP_VERSION);
    return;
  }

  if (storedVersion !== APP_VERSION) {
    // Version changed - force reload
    localStorage.setItem(STORAGE_KEY, APP_VERSION);
    
    // Clear all caches
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }

    // Clear service worker cache if registered
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => reg.unregister());
      });
    }

    // Show update message and reload
    const shouldReload = window.confirm(
      'A new version of ArtistDesk is available. The app will reload to update.'
    );
    
    if (shouldReload) {
      window.location.reload();
    }
  }
}

// Force reload on iOS home screen app if accessed via deep link
export function handleDeepLinkRefresh() {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                       (window.navigator as any).standalone === true;

  if (isStandalone) {
    // For iOS PWA, check if we need to force refresh on navigation
    const LAST_LOAD_KEY = 'last_load_time';
    const lastLoad = localStorage.getItem(LAST_LOAD_KEY);
    const now = Date.now();
    
    if (lastLoad && (now - parseInt(lastLoad, 10)) > 86400000) { // 24 hours
      // Clear old data
      localStorage.setItem(LAST_LOAD_KEY, now.toString());
      window.location.reload();
    } else {
      localStorage.setItem(LAST_LOAD_KEY, now.toString());
    }
  }
}
